export default {
    SET_RESET_REQUEST: 'SET_RESET_REQUEST',

    START_FETCHING_RESET: 'START_FETCHING_RESET',
    STOP_FETCHING_RESET: 'STOP_FETCHING_RESET',

    SET_ERRORS_RESET: 'SET_ERRORS_RESET',
    SET_ERROR_RESET: 'SET_ERROR_RESET',

    SET_CODE_RESET_REQUEST: 'SET_CODE_RESET_REQUEST',

    SET_NEW_PASSWORD_CHANGE_REQUEST: 'SET_NEW_PASSWORD_CHANGE_REQUEST',
};